module.exports = __webpack_public_path__ + "static/img/banner-02.dca474b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/banner-02.jpg
// module id = cTR0
// module chunks = 7